export default __webpack_public_path__ + "static/media/Calendar.80fd053c.svg";